<template>

    <v-content>
        <v-breadcrumbs :items="breadCrumbs" large></v-breadcrumbs>
        <v-dialog v-model="snackbar.formModal"
                  transition="dialog-bottom-transition"
                  persistent
                  max-width="1000px">
            <v-card>
                <Create @dialogueClose="dialogueClose"
                        @formResponse="formResponse"
                        v-if="snackbar.createFormComponent"></Create>
                <EditForm @dialogueClose="dialogueClose"
                          @formResponse="formResponse"
                          v-if="snackbar.editFormComponent"
                          :editItemIndex="editSamikshyaIndex"
                          :key="index"></EditForm>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.snackbar"
                    :color="snackbar.color"
                    :timeout="snackbar.timeout"
                    top>
            {{ snackbar.text }}
            <v-btn dark
                   text
                   @click="snackbar.snackbar = false">
                Close
            </v-btn>
        </v-snackbar>
        <div class="fixTableHead">
            <table class="table tbl">
                <thead>
                    <div slot="table-actions">
                        <div class="my-1">
                            <v-btn color="primary" @click.stop="addModal">{{$t('form')}}</v-btn>
                        </div>
                    </div>
                    <tr>
                        <th rowspan="2">{{$t('s_no')}}</th>
                        <th rowspan="2">{{$t('report')}} {{$t('name')}}</th>
                        <th rowspan="2"> {{$t('year')}}</th>
                        <th rowspan="2"> {{$t('actions')}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(listData,index) in listDatas" :key="listData.id">
                        <td>{{index+1}}</td>
                        <td>{{listData.name}}</td>
                        <td>{{listData.year}}</td>
                        <td>
                            <router-link :to="`/samikxya/${listData.samikshyaReportID}`">
                                <v-btn color="primary">View</v-btn>
                            </router-link>
                            <v-btn color="primary ml-4" @click="editModal(listData.samikshyaReportID)">Edit</v-btn>
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
    </v-content>
</template>

<script>
    import axios from "axios";
    import { mapGetters } from "vuex";
    import Create from "./create";
    import EditForm from "./edit";

    export default {
        name: 'AnucharuIndex',
        watch: {},
        components: {
            Create,
            EditForm
        },
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            breadCrumbs() {
                return [
                    {
                        text: this.$t('dashboard'),
                        disabled: false,
                        to: `${this.usersData.dashBoard}`,
                        exact: true
                    },
                    {
                        text: this.$t('samikshya_Report'),
                        disabled: true,
                    },
                ]
            },
        },

        data() {
            return {
                index:0,
                editSamikshyaIndex:0,
               
                IsActive: false,
                headers: [],
                titleHeaders: [],
                listDatas:[],
                snackbar: {
                    color: '',
                    snackbar: false,
                    text: '',
                    timeout: 6000,
                    isLoading: false,
                    formModal: false,
                    createFormComponent: false,
                    editFormComponent: false,
                    dialogDelete: false,
                    dynamicComponent: {
                        current: 'HeaderForm'
                    }
                }
            };
        },
        mounted() {
            this.loadApi()
            //this.breadCrumbData()
        },
        methods: {
            loadApi(){
                axios.get('SamikshyaReport/SamikshyaReportList').then(response => {
                    this.listDatas = response.data
                    this.breadCrumbData()
                }).catch(err=>{
                    console.log(err)})
            },
          
            breadCrumbData(){
               

            },
            nullTitle( title ) {
                return title == null
            },
            addModal() {
                this.snackbar.formModal = true
                this.snackbar.createFormComponent = true
                this.snackbar.editFormComponent = false

            },
            editModal(item) {
                console.log(item)
                this.index++;
                this.snackbar.formModal = true
                this.snackbar.editFormComponent = true
                this.snackbar.createFormComponent = false

                this.editSamikshyaIndex = item
            },
            dialogueClose() {
                this.snackbar.formModal = false
                this.snackbar.createFormComponent = false
                this.loadApi()
            },
            formResponse(responseObj) {
                console.log(responseObj)
                this.snackbar.color = responseObj.status ? 'green' : 'red'
                this.snackbar.text = responseObj.text ? responseObj.text : 'Server Error'
                this.snackbar.snackbar = true
                this.loadApi();
            },
        }
    };
</script>

<style lang="scss" scoped>

    .v-sheet--offset {
        top: -24px;
        position: relative;
    }

    .fixTableHead {
        overflow-y: auto;
        height: 631px;
    }

    .fixTableHead thead th {
        position: sticky;
        top: 0;
        z-index: 1;
    }

    .tbl th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: $main-color;
        color: white;
    }

    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 15px;
    }
</style>
